import Axios from "axios";
import mixpanel from "mixpanel-browser";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContextConstants, useAppContext } from "../Context/AppContext";
import firebase from "../Firebase";
import "./App.css";
import { MIXPANEL_TOKEN } from "../config/env.config";
import AppLayout from "./AppLayout";
import Login from "./Login/Login";
import Loader from "./Shared/Loader";

const App = () => {
  const [content, setContent] = useState();
  const mixpanelId = MIXPANEL_TOKEN;
  mixpanel.init(mixpanelId);
  const { dispatch } = useAppContext();

  useEffect(() => {
    Axios.get("https://api.ipify.org?format=json").then((res) => {
      dispatch({
        type: ContextConstants.clientIp,
        payload: res?.data?.ip,
      });
    });

    firebase.getAuth.onAuthStateChanged((user) => {
      if (user) {
        firebase
          .getAccessToken()
          .then((d) => {
            // comment out below popup as the data is outdated, transporters are complaining
            // if (!localStorage.getItem("showPopup")) {
            //   localStorage.setItem("showPopup", "yes");
            // }
            setContent(<AppLayout />);
          })
          .catch((e) => console.log(e));
      } else {
        setContent(<Login />);
      }
    });
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={6000}
        style={{ zIndex: "999999999999999999" }}
      />
      {content === undefined ? (
        <>
          <Loader show={content === undefined} />
        </>
      ) : (
        <>{content}</>
      )}
    </>
  );
};

export default App;
